export default "__VITE_ASSET__C43gcE1Q__"